import React from "react";
import { texts } from "../../general/texts";
import colors from "../../colors";
import { makeStyles } from '@mui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { ReactComponent as ConfirmedFriend } from "../../../icons/ConfirmedFriend.svg";
import { ReactComponent as HourglassPendingFriend } from "../../../icons/HourglassPendingFriend.svg";


const FriendsList = ({ list }) => {

    const isSmallScreen = useMediaQuery('(max-width:600px)');

    const useStyles = makeStyles({
        referencesCard: {
            display: 'flex',
            flexDirection: isSmallScreen ? 'column' : 'row',
            padding: "25px",
            width: isSmallScreen ? "90vw" : "915px",
            height: isSmallScreen ? "40vh" : "370px",
            borderRadius: "14px",
            textAlign: isSmallScreen ? "center" : "left",
            borderRadius: "15px",
            marginTop: "80px",
            justifyContent: isSmallScreen ? '' : 'space-between',
            background: colors.white
        },
        scrollBar: {
            "&::-webkit-scrollbar": {
                width: "4px",
                height: "50%",
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "#FFFFFF",
                borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
                background: colors.gray,
                borderRadius: "8px",
                maxHeight: "50%",
            },
            "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "linear-gradient(to bottom, #EF7A30, #F0A13D)",
            },
        }
    });

    const classes = useStyles();

    return (
        <div className={classes.referencesCard}>
            <span style={{ fontSize: '30px', fontWeight: 700, color: colors.orange}}>{texts['title-invited-friends']}</span>
            <div className={classes.scrollBar} style={{ marginRight: '55px', marginTop: isSmallScreen ? '60px' : '90px', height: '220px', width: isSmallScreen ? '90vw' : '550px', overflowY: 'auto' }}>
                {list.length > 0 && list.map((confirmCode, index) => (
                    <div key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '15px' }}>
                            {confirmCode.rewarded ?
                                <ConfirmedFriend style={{ background: colors.orange, padding: '8px', borderRadius: '50px', height: '25px', width: '25px', marginRight: '15px' }} /> :
                                <HourglassPendingFriend style={{ background: colors.orange, padding: '8px', borderRadius: '50px', height: '25px', width: '25px', marginRight: '15px' }} />
                            }
                            <span style={{ fontSize: '18px', fontWeight: 700, color: colors.darkBlue, marginTop: 8 }}>{confirmCode.confirmedBy}</span>
                        </div>
                        {confirmCode.rewarded &&
                            <span style={{ fontSize: '15px', fontWeight: 750, color: '#7A9C68', marginRight: '10px' }}>+500 ALL</span>
                        }
                    </div>
                )
                )}
            </div>
        </div>
    )
}

export default FriendsList;